<dx-popup
  #popupChangePassword
  class="popup"
  minWidth="300px"
  width="375px"
  height="auto"
  [showTitle]="true"
  [title]="title"
  [dragEnabled]="true"
  [hideOnOutsideClick]="false"
  [(visible)]="popupVisible"
  (onShown)="repaint()"
>
  <div *dxTemplate="let data of 'content'">
    <dx-validation-group #validatorChangePassword>
      <dx-box class="change-password-container" direction="col" width="100%">
        <dxi-item baseSize="auto" class="change-password-dxi-item">
          <dx-text-box
            #currentPassword
            class="text-input cc-text-required"
            placeholder="Current Password"
            [(mode)]="passwordMode"
            [(value)]="changePasswordInfo.currentPassword"
            [inputAttr]="{ autocomplete: 'new-password' }"
            placeholder="Current Password"
          >
            <dxi-button
              *ngIf="passwordMode === 'password'"
              name="password"
              location="after"
              [options]="passwordShowButton"
            ></dxi-button>
            <dxi-button
              *ngIf="passwordMode !== 'password'"
              name="password"
              location="after"
              [options]="passwordHideButton"
            ></dxi-button>
            <dx-validator>
              <dxi-validation-rule
                type="required"
                message="Current Password is required"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </dxi-item>
        <dxi-item baseSize="auto" class="change-password-dxi-item">
          <dx-text-box
            #newPassword
            class="text-input cc-text-required"
            placeholder="New Password"
            [(mode)]="passwordMode"
            [(value)]="changePasswordInfo.newPassword"
            [inputAttr]="{ autocomplete: 'new-password' }"
            (onKeyUp)="runPasswordValidation($event)"
          >
            <dxi-button
              *ngIf="passwordMode === 'password'"
              name="password"
              location="after"
              [options]="passwordShowButton"
            ></dxi-button>
            <dxi-button
              *ngIf="passwordMode !== 'password'"
              name="password"
              location="after"
              [options]="passwordHideButton"
            ></dxi-button>
            <dx-validator>
              <dxi-validation-rule
                type="required"
                message="New Password is required"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </dxi-item>
        <dxi-item baseSize="auto" class="change-password-dxi-item">
          <dx-text-box
            #confirmPassword
            class="text-input cc-text-required"
            placeholder="Confirm Password"
            [(mode)]="passwordMode"
            [inputAttr]="{ autocomplete: 'new-password' }"
          >
            <dxi-button
              *ngIf="passwordMode === 'password'"
              name="password"
              location="after"
              [options]="passwordShowButton"
            ></dxi-button>
            <dxi-button
              *ngIf="passwordMode !== 'password'"
              name="password"
              location="after"
              [options]="passwordHideButton"
            ></dxi-button>
            <dx-validator>
              <dxi-validation-rule
                type="required"
                message="Confirm Password is required"
              ></dxi-validation-rule>
              <dxi-validation-rule
                type="compare"
                [comparisonTarget]="passwordComparison"
                comparisonType="==="
                message="Password and Confirm Password do not match"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </dxi-item>
        <dxi-item baseSize="auto" class="change-password-dxi-item">
          <div>
            <dx-progress-bar
              #passwordStrengthIndicator
              [min]="0"
              [max]="5"
              [statusFormat]="getPasswordStrength"
            ></dx-progress-bar>
          </div>
        </dxi-item>
        <dxi-item baseSize="auto" class="change-password-dxi-item">
          <ul class="password-rules">
            <li *ngFor="let rule of passwordRules">
              <i
                [ngClass]="[
                  iconCircleCheck,
                  rule.isValid ? 'cc-icon-green' : 'cc-icon-lightgreen'
                ]"
              ></i>
              <span [ngClass]="{ 'cc-text-required': !rule.isValid }">
                {{ rule.label }}
              </span>
            </li>
          </ul>
        </dxi-item>
        <dxi-item baseSize="auto" class="change-password-dxi-item">
          <dx-box
            direction="row"
            width="100%"
            class="change-password-buttons-container"
            align="end"
            crossAlign="center"
          >
            <dxi-item [ratio]="1">
              <dx-button
                type="default"
                [icon]="cancelButtonIcon"
                [width]="100"
                text="Cancel"
                (onClick)="popupVisible = false"
              ></dx-button>
            </dxi-item>
            <dxi-item baseSize="auto">
              <dx-button
                type="success"
                [icon]="saveButtonIcon"
                [width]="100"
                text="Save"
                (onClick)="btnSaveClick()"
              ></dx-button>
            </dxi-item>
          </dx-box>
        </dxi-item>
      </dx-box>
    </dx-validation-group>
  </div>
</dx-popup>

<cc-message-box #messageBox></cc-message-box>

<dx-load-panel
  #loadPanelChangePassword
  shadingColor="rgba(0,0,0,0.4)"
  [position]="{ of: '#popupChangePassword' }"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
></dx-load-panel>
